export default __webpack_public_path__ + "static/button-label-dont-addc87c307edd4341579a9d33cd1759f28c65ac435939fb63689259c172658e8.png";